// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Canvas slide-over Data Catalog drawer — what is specific to this drawer.
 *
 * The panel itself is the shared
 * ../../packages/publishing/CatalogDrawerShell.module.css, which the Node
 * Catalog drawer also imports; header, search row, tab strip and footer are the
 * shared packages/publishing components.
 */

/* This drawer sits one tier above the node drawer, because the dataset detail
   modal can open on top of it (see curioTokens.css). */
.LJgm5yaXryNiuvaFSbZk {
  --curio-drawer-z: var(--curio-z-dataset-drawer);
}

/* Loading skeletons. Specific to this drawer: the dataset catalog is fetched
   over the network on open, where the package list is already in memory. */
.S43uW4MtkZmPwNCgtOCb {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.suy8eqH_9EmmOvq_Eax8 {
  height: 72px;
  border-radius: var(--curio-radius-md);
  background: linear-gradient(90deg, #eceae4 0%, #f5f4f0 50%, #eceae4 100%);
  background-size: 200% 100%;
  animation: DaIgel9kxK_dj4uU9kRt 1.2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .suy8eqH_9EmmOvq_Eax8 {
    animation: none;
  }
}

@keyframes DaIgel9kxK_dj4uU9kRt {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetCatalogDrawer.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;uDACuD;AACvD;EACE,+CAA+C;AACjD;;AAEA;2EAC2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,yEAAyE;EACzE,0BAA0B;EAC1B,yDAA2D;AAC7D;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/*\n * Canvas slide-over Data Catalog drawer — what is specific to this drawer.\n *\n * The panel itself is the shared\n * ../../packages/publishing/CatalogDrawerShell.module.css, which the Node\n * Catalog drawer also imports; header, search row, tab strip and footer are the\n * shared packages/publishing components.\n */\n\n/* This drawer sits one tier above the node drawer, because the dataset detail\n   modal can open on top of it (see curioTokens.css). */\n.overlayRoot {\n  --curio-drawer-z: var(--curio-z-dataset-drawer);\n}\n\n/* Loading skeletons. Specific to this drawer: the dataset catalog is fetched\n   over the network on open, where the package list is already in memory. */\n.skeletonList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.skeletonCard {\n  height: 72px;\n  border-radius: var(--curio-radius-md);\n  background: linear-gradient(90deg, #eceae4 0%, #f5f4f0 50%, #eceae4 100%);\n  background-size: 200% 100%;\n  animation: catalogSkeletonShimmer 1.2s ease-in-out infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skeletonCard {\n    animation: none;\n  }\n}\n\n@keyframes catalogSkeletonShimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `LJgm5yaXryNiuvaFSbZk`,
	"skeletonList": `S43uW4MtkZmPwNCgtOCb`,
	"skeletonCard": `suy8eqH_9EmmOvq_Eax8`,
	"catalogSkeletonShimmer": `DaIgel9kxK_dj4uU9kRt`
};
export default ___CSS_LOADER_EXPORT___;
